import en from './en/index';
import fr from './fr/index';

const localizedTexts = { en , fr };

export {
    localizedTexts,
};
